import * as angular from 'angular';
import {IController} from "angular";

export class EditDeliveriesTimeWindowComponent implements IController {
  isEditPerTask: boolean;
  pickupDate: any;
  pickupNotBefore: number;
  pickupNotAfter: number;
  dropoffDate: any;
  dropoffNotBefore: number;
  dropoffNotAfter: number;

  onPickupDateChanged: Function;
  onPickupNotBeforeTimeChange: Function;
  onPickupNotAfterTimeChange: Function;
  onDropoffDateChanged: Function;
  onDropoffNotBeforeTimeChange: Function;
  onDropoffNotAfterTimeChange: Function;

}

angular
  .module('bringoz.admin.deliveries')
  .component('editDeliveriesTimeWindow', {
    require: {
      form: '?^form'
    },
    bindings: {
      isEditPerTask: '<?',
      pickupDate: '<?',
      pickupNotBefore: '<?',
      pickupNotAfter: '<?',
      dropoffDate: '<?',
      dropoffNotBefore: '<?',
      dropoffNotAfter: '<?',
      onPickupDateChanged: '&',
      onPickupNotBeforeTimeChange: '&',
      onPickupNotAfterTimeChange: '&',
      onDropoffDateChanged: '&',
      onDropoffNotBeforeTimeChange: '&',
      onDropoffNotAfterTimeChange: '&'
    },
    template: require('./edit-deliveries-time-window.html').default,
    controller: EditDeliveriesTimeWindowComponent
  });
